import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetPasswordSecurityModel } from '@core/services/auth/auth.model';
import { AuthService } from '@core/services/auth/auth.service';
import { mustMatchValidator } from '@shared/directives/must-match.directive';

@Component({
  selector: 'Teranet-ResetPasswordSecurity',
  templateUrl: './reset-password-security.component.html'
})
export class ResetPasswordSecurityComponent implements OnInit {
  resetPasswordForm: FormGroup;
  resetPasswordModel: ResetPasswordSecurityModel;
  errorMessage: Array<string> = [];
  isError: boolean;
  isPasswordWeak: boolean = false;
  previousUrl: string;
  isTokenValid: boolean;

  constructor(private authService: AuthService, private activatedRoute: ActivatedRoute, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    this.resetPasswordModel = new ResetPasswordSecurityModel(); 
    this.resetPasswordForm = this.fb.group(
      {
        'password': new FormControl('', Validators.compose([Validators.required, Validators.minLength(10)])),
        'confirmpassword': new FormControl('', Validators.compose([Validators.required]))
      },
      {
        validator: mustMatchValidator('password', 'confirmpassword')
      });
    this.activatedRoute.queryParams.subscribe(params => {
      this.resetPasswordModel.userId = params['userId'];
      this.resetPasswordModel.token = params['token'];
      this.verifyToken();
    });
  }

  verifyToken() {
    this.authService.verifyToken(this.resetPasswordModel).subscribe(x => {
      this.isTokenValid = x;
    });
  }

  onOk() {
    this.router.navigate(['login']);
  }

  onCancel() {
    this.router.navigate(['login']);
  }

  OnSubmit() {
    this.isError = null;
    this.errorMessage = [];
    this.isPasswordWeak = false;
    if (this.resetPasswordForm.valid) {
      this.authService.resetAuthPassword(this.resetPasswordModel).subscribe(x => {
        this.isError = false;
        this.router.navigate(['login']);
      },
        (err: HttpErrorResponse) => {
          this.isError = true;
          if (this.isIterable(err.error)) {
            for (var item of err.error) {
              if (!this.isPasswordWeak && item.code !== "PreviousPassword") {
                this.isPasswordWeak = true;
              }
              this.errorMessage.push(item.description);
            }
          }
          else {
            this.errorMessage.push(err.error.errors.NewPassword);
          }
        });
    }
  }

  isIterable(obj) {
    if (obj == null) {
      return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
  }
}
